import { render, staticRenderFns } from "./DatasetName.vue?vue&type=template&id=2831d732&scoped=true"
import script from "./DatasetName.vue?vue&type=script&lang=js"
export * from "./DatasetName.vue?vue&type=script&lang=js"
import style0 from "./DatasetName.vue?vue&type=style&index=0&id=2831d732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2831d732",
  null
  
)

export default component.exports